<template>
  <v-dialog
    v-model="dialog"
    content-class="combook-binding-cover-design-dialog"
    width="100%"
    max-width="500px"
  >
    <div class="text-xs-right">
      <v-btn flat icon color="primary" @click.native="onCloseDialog">
        <img src="../../../../assets/images/close_icon.svg" alt="close" />
      </v-btn>
    </div>

    <div class="image-wrapper">
      <img :src="imageFilePath" :alt="designType" />
    </div>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialogValue: {
      type: Boolean,
      default: false
    },
    designType: {
      type: String,
      default: ""
    }
  },
  computed: {
    dialog: {
      get() {
        return this.dialogValue;
      },
      set(value) {
        this.onCloseDialog();
      }
    },
    imageFilePath() {
      if (this.designType === "pastel") {
        return require("../../../../assets/images/combook_binding/cover_design/pastel.png");
      } else if (this.designType === "simple") {
        return require("../../../../assets/images/combook_binding/cover_design/simple.png");
      } else {
        return "";
      }
    }
  },
  methods: {
    onCloseDialog() {
      this.$emit("close-dialog");
    }
  }
};
</script>

<style scoped>
.image-wrapper {
  padding: 24px 16px 16px 16px;
  margin: 0px 8px 8px;
  box-sizing: border-box;
  background: #f3f2f1;
  border-radius: 4px;
  text-align: center;
}
</style>

<style>
.combook-binding-cover-design-dialog {
  margin: 12px;
  background-color: #ffffff;
}
</style>
